import React, { useState } from 'react';

const TDBEmployesModule = () => {
  const [activeView, setActiveView] = useState('vue-global');

  const EMP = [
    {
      id: 1, av: "KH", prenom: "Karmelle", nom: "HAZOUMÈ", poste: "Ass. Tech. Projets", filiale: "FHC Siège", color: "#C9A84C",
      score: 9.1, scoreLabel: "Excellent", present: true, tachesQuot: 6, tachesDone: 5, ponctualite: 100, retards: 0
    },
    {
      id: 2, av: "JA", prenom: "Jean-Paul", nom: "ADÉWOLÉ", poste: "Développeur Web", filiale: "FHC Techno.", color: "#42a5f5",
      score: 6.8, scoreLabel: "Satisfaisant", present: true, tachesQuot: 5, tachesDone: 1, ponctualite: 43, retards: 4
    },
    {
      id: 3, av: "MB", prenom: "Marie", nom: "BIOKOU", poste: "Comptable", filiale: "FHC Conseil", color: "#66bb6a",
      score: 8.7, scoreLabel: "Très bien", present: true, tachesQuot: 5, tachesDone: 3, ponctualite: 86, retards: 1
    },
    {
      id: 4, av: "OK", prenom: "Ola", nom: "KOSSOU", poste: "Formateur Senior", filiale: "FHC Formation", color: "#ab47bc",
      score: 8.2, scoreLabel: "Très bien", present: true, tachesQuot: 4, tachesDone: 3, ponctualite: 100, retards: 0
    },
    {
      id: 5, av: "SD", prenom: "Serge", nom: "DOSSOU", poste: "Commercial / Insertion", filiale: "EMPLOI+", color: "#ff9800",
      score: 7.6, scoreLabel: "Bien", present: false, tachesQuot: 3, tachesDone: 2, ponctualite: 57, retards: 3
    },
    {
      id: 6, av: "DM", prenom: "Diane", nom: "MONTEIRO", poste: "Marketing Digital", filiale: "FHC Siège", color: "#26c6da",
      score: 7.9, scoreLabel: "Bien", present: true, tachesQuot: 5, tachesDone: 3, ponctualite: 100, retards: 0
    },
    {
      id: 7, av: "AF", prenom: "Ayodele", nom: "FAWOLE", poste: "Développeur Mobile", filiale: "FHC Techno.", color: "#ef5350",
      score: 4.2, scoreLabel: "À améliorer", present: false, tachesQuot: 5, tachesDone: 0, ponctualite: 14, retards: 6
    },
    {
      id: 8, av: "PL", prenom: "Patrick", nom: "LOKO", poste: "Agent Immobilier", filiale: "FHC Location", color: "#78909c",
      score: 5.5, scoreLabel: "Insuffisant", present: false, tachesQuot: 4, tachesDone: 0, ponctualite: 43, retards: 4
    }
  ];

  const kpiPresent = EMP.filter(e => e.present).length;
  const kpiRetards = EMP.reduce((s, e) => s + e.retards, 0);
  const kpiAccomp = Math.round((EMP.reduce((s, e) => s + (e.tachesDone / e.tachesQuot * 100), 0) / EMP.length));
  const kpiScore = (EMP.reduce((s, e) => s + e.score, 0) / EMP.length).toFixed(1);

  return (
    <div style={{ background: '#090f1a', minHeight: '100vh', fontFamily: 'DM Sans, sans-serif', fontSize: 13, color: '#fff' }}>
      {/* TOPBAR */}
      <div style={{
        height: 54,
        background: '#0d1825',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        position: 'sticky',
        top: 0,
        zIndex: 300
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 32,
            height: 32,
            borderRadius: 8,
            background: 'linear-gradient(135deg,#C9A84C,#8a6028)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 16,
            boxShadow: '0 2px 10px rgba(201,168,76,.3)'
          }}>📊</div>
          <div>
            <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 18, fontWeight: 600 }}>
              FHC Groupe SARL — Tableau de Bord RH
            </div>
            <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', letterSpacing: 0.5 }}>
              Direction Générale · Vue centralisée temps réel
            </div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            fontSize: 10,
            color: '#445',
            background: '#111f2e',
            padding: '4px 11px',
            borderRadius: 20,
            border: '1px solid rgba(255,255,255,0.06)'
          }}>
            {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
          </div>
          <button style={{
            background: 'rgba(201,168,76,0.12)',
            border: '1px solid rgba(201,168,76,0.3)',
            borderRadius: 6,
            padding: '5px 13px',
            color: '#C9A84C',
            fontSize: 11,
            cursor: 'pointer'
          }}>
            ↻ Actualiser
          </button>
        </div>
      </div>

      {/* NAV TABS */}
      <div style={{
        background: '#0d1825',
        borderBottom: '1px solid rgba(255,255,255,0.06)',
        padding: '0 24px',
        display: 'flex',
        gap: 2,
        position: 'sticky',
        top: 54,
        zIndex: 200,
        overflowX: 'auto'
      }}>
        {[
          { id: 'vue-global', label: '🧭 Vue globale' },
          { id: 'vue-taches', label: '✅ Tâches du jour', badge: EMP.reduce((s, e) => s + (e.tachesQuot - e.tachesDone), 0) },
          { id: 'vue-presence', label: '📍 Présence & Pointage', badge: kpiPresent },
          { id: 'vue-performance', label: '⭐ Performance & Scores' },
          { id: 'vue-objectifs', label: '🎯 Objectifs' },
          { id: 'vue-alertes', label: '⚠️ Alertes', badge: 3 }
        ].map(tab => (
          <div
            key={tab.id}
            onClick={() => setActiveView(tab.id)}
            style={{
              padding: '11px 18px',
              fontSize: 12,
              color: activeView === tab.id ? '#C9A84C' : '#667',
              cursor: 'pointer',
              borderBottom: activeView === tab.id ? '2px solid #C9A84C' : '2px solid transparent',
              transition: 'all 0.15s',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              gap: 6
            }}
          >
            {tab.label}
            {tab.badge !== undefined && (
              <span style={{
                fontSize: 9,
                fontWeight: 700,
                padding: '1px 5px',
                borderRadius: 99,
                background: tab.id === 'vue-presence' ? 'rgba(67,160,71,0.2)' : 'rgba(229,57,53,0.25)',
                color: tab.id === 'vue-presence' ? '#66bb6a' : '#ef8080'
              }}>
                {tab.badge}
              </span>
            )}
          </div>
        ))}
      </div>

      {/* MAIN */}
      <div style={{ padding: '20px 24px 40px' }}>
        {/* VUE GLOBALE */}
        {activeView === 'vue-global' && (
          <div>
            {/* KPIs */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 10, marginBottom: 20 }}>
              <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#1976d2' }} />
                <div style={{ fontSize: 18, marginBottom: 6 }}>👥</div>
                <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, lineHeight: 1, marginBottom: 2 }}>{EMP.length}</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)' }}>Collaborateurs</div>
              </div>
              <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#43a047' }} />
                <div style={{ fontSize: 18, marginBottom: 6 }}>✅</div>
                <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, lineHeight: 1, marginBottom: 2 }}>{kpiPresent}</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)' }}>Présents aujourd'hui</div>
                <div style={{ fontSize: 9, marginTop: 5, padding: '2px 6px', borderRadius: 99, display: 'inline-block', background: 'rgba(67,160,71,0.15)', color: '#66bb6a' }}>
                  {Math.round(kpiPresent / EMP.length * 100)}%
                </div>
              </div>
              <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#fb8c00' }} />
                <div style={{ fontSize: 18, marginBottom: 6 }}>⏰</div>
                <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, lineHeight: 1, marginBottom: 2 }}>{kpiRetards}</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)' }}>Retards ce mois</div>
              </div>
              <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#C9A84C' }} />
                <div style={{ fontSize: 18, marginBottom: 6 }}>📊</div>
                <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, lineHeight: 1, marginBottom: 2 }}>{kpiAccomp}%</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)' }}>Taux accompl. moyen</div>
                <div style={{ fontSize: 9, marginTop: 5, padding: '2px 6px', borderRadius: 99, display: 'inline-block', background: 'rgba(255,255,255,0.05)', color: '#888' }}>
                  Tâches du jour
                </div>
              </div>
              <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#ab47bc' }} />
                <div style={{ fontSize: 18, marginBottom: 6 }}>⭐</div>
                <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, lineHeight: 1, marginBottom: 2 }}>{kpiScore}</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)' }}>Score moyen /10</div>
              </div>
              <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 10, padding: '14px 16px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 2, background: '#00897b' }} />
                <div style={{ fontSize: 18, marginBottom: 6 }}>🎯</div>
                <div style={{ fontFamily: 'Cormorant Garamond, serif', fontSize: 26, fontWeight: 600, lineHeight: 1, marginBottom: 2 }}>—</div>
                <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.4)' }}>Objectifs atteints</div>
              </div>
            </div>

            {/* Tableau principal */}
            <div style={{ background: '#111f30', border: '1px solid rgba(255,255,255,0.06)', borderRadius: 12, overflow: 'hidden', marginBottom: 20 }}>
              <div style={{
                display: 'grid',
                gridTemplateColumns: '220px 120px 130px 130px 140px 100px 80px',
                padding: '10px 16px',
                background: 'rgba(255,255,255,0.02)',
                borderBottom: '1px solid rgba(255,255,255,0.06)',
                gap: 8
              }}>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', color: '#445' }}>Collaborateur</div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', color: '#445' }}>Présence</div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', color: '#445' }}>Tâches du jour</div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', color: '#445' }}>Score /10</div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', color: '#445' }}>Ponctualité</div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', color: '#445' }}>Retards</div>
                <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: 0.8, textTransform: 'uppercase', color: '#445' }}>Actions</div>
              </div>
              {EMP.map(emp => (
                <div
                  key={emp.id}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '220px 120px 130px 130px 140px 100px 80px',
                    padding: '12px 16px',
                    gap: 8,
                    borderBottom: '1px solid rgba(255,255,255,0.03)',
                    alignItems: 'center',
                    cursor: 'pointer',
                    transition: 'background 0.15s'
                  }}
                  onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.025)'}
                  onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{
                      width: 32,
                      height: 32,
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 11,
                      fontWeight: 700,
                      flexShrink: 0,
                      background: `${emp.color}22`,
                      color: emp.color
                    }}>
                      {emp.av}
                    </div>
                    <div>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#fff' }}>{emp.prenom} {emp.nom}</div>
                      <div style={{ fontSize: 9, color: '#556' }}>{emp.poste}</div>
                    </div>
                  </div>
                  <div>
                    <div style={{
                      fontSize: 10,
                      fontWeight: 600,
                      color: emp.present ? '#66bb6a' : '#ef8080'
                    }}>
                      {emp.present ? '✅ Présent' : '❌ Absent'}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: '#aaa', marginBottom: 4 }}>
                      {emp.tachesDone}/{emp.tachesQuot}
                    </div>
                    <div style={{ background: 'rgba(255,255,255,0.06)', borderRadius: 99, height: 4, overflow: 'hidden' }}>
                      <div style={{
                        width: `${emp.tachesDone / emp.tachesQuot * 100}%`,
                        height: '100%',
                        borderRadius: 99,
                        background: emp.tachesDone / emp.tachesQuot >= 0.8 ? '#43a047' : emp.tachesDone / emp.tachesQuot >= 0.5 ? '#fb8c00' : '#e53935'
                      }} />
                    </div>
                  </div>
                  <div>
                    <div style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: 36,
                      height: 36,
                      borderRadius: '50%',
                      fontFamily: 'Cormorant Garamond, serif',
                      fontSize: 16,
                      fontWeight: 600,
                      border: `2px solid ${emp.score >= 8 ? '#43a047' : emp.score >= 6 ? '#fb8c00' : '#e53935'}`,
                      color: emp.score >= 8 ? '#43a047' : emp.score >= 6 ? '#fb8c00' : '#e53935'
                    }}>
                      {emp.score}
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600 }}>{emp.ponctualite}%</div>
                  </div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 600, color: emp.retards > 0 ? '#ef8080' : '#66bb6a' }}>
                      {emp.retards}
                    </div>
                  </div>
                  <div>
                    <button style={{
                      fontSize: 9,
                      padding: '3px 8px',
                      background: 'transparent',
                      border: '1.5px solid rgba(255,255,255,0.06)',
                      borderRadius: 7,
                      color: '#888',
                      cursor: 'pointer'
                    }}>
                      👁️
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Other views - Placeholder */}
        {activeView !== 'vue-global' && (
          <div style={{ textAlign: 'center', padding: '60px 20px' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>
              {activeView === 'vue-taches' && '✅'}
              {activeView === 'vue-presence' && '📍'}
              {activeView === 'vue-performance' && '⭐'}
              {activeView === 'vue-objectifs' && '🎯'}
              {activeView === 'vue-alertes' && '⚠️'}
            </div>
            <div style={{ fontSize: 16, color: '#C9A84C', marginBottom: 8 }}>
              {activeView === 'vue-taches' && 'Tâches du jour — Vue DG'}
              {activeView === 'vue-presence' && 'Présence & Pointage'}
              {activeView === 'vue-performance' && 'Performance & Scores — Vue DG'}
              {activeView === 'vue-objectifs' && 'Objectifs — Vue DG'}
              {activeView === 'vue-alertes' && 'Alertes & Notifications RH'}
            </div>
            <div style={{ fontSize: 13, color: '#667' }}>
              Vue détaillée à venir
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TDBEmployesModule;
